import ReactOnRails from 'react-on-rails'

// this import gets changed by webpack to ./reg-server in the server bundle
import components from './reg-client'

ReactOnRails.register(components)
